const CellState = Object.freeze({
  INIT: 'inactive',
  ACTIVE: 'active',
  MATCH: 'match',
  CONTAINS: 'contains',
  MISS: 'miss',
});

export default CellState;
